import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import I18n from 'redux-i18n';
import merge from 'deepmerge';
import MobileDetect from 'mobile-detect';
import { BookingForm, setFormVisible, translations as bookingFormTranslations } from 'bookingform';
import {
  BOOKING_STEP, DEVICES, sendGTMEvents, setDevice, initializeSignalR, processIpClientCountryCode,
} from '../actions/Booking';
import { loadAndConfigureChain, setShowAlertMobileLand, setTheme } from '../actions/Session';
import { configureAnalytics } from '../utils/Analytics';

import { CALL_CENTER_ROLE, chainGTMs, chains } from '../constants';

import BookingFormSummary from './booking/BookingFormSummary';
import AlertMobileLand from './AlertMobileLand';
import Breadcrumbs from './common/Breadcrumbs';
import DsCardError from './ds/atoms/card/cardError';
import Footer from './Footer';
import Header from './Header';
import CookieBanner from './common/CookieBanner';

import '../static/images/SANDOS_icon.ico';
import '../static/images/MARCONFORT_icon.ico';
import '../static/images/PALMAIARESORTS_icon.ico';
import '../static/images/loading5.gif';
// We need to merge bookingform translations with the engine ones
import { translations as engineTranslations } from '../translations';
import Login2 from './loyalty/Login2';
import UserRegistration from './loyalty/UserRegistration2';
import { getConversionRates, login } from '../actions/Loyalty';
import { existCookie, getCookieValue } from '../services/cookies';
import RecoverPasswordModal from './loyalty/RecoverPassword';
import withNavigate from '../withNavigate'; // Importa el HOC
import BookNowRegisterReminder from './loyalty/BookNowRegisterReminder';
import EditBookingContactInfoPopup from './booking/edit-bookings/EditBookingContactInfoPopup';
import SomeRoomsNotAvailablePopUp from './booking/edit-bookings/SomeRoomsNotAvailablePopUp';
import { showLoyaltyRegisterNow } from '../utils';

// Language names are not detected with npm run extract, so we add translations manually
const langTranslations = {
  de: {
    Spanish: 'Spanisch',
    English: 'Englisch',
    German: 'Deutsch',
  },
  es: {
    Spanish: 'Español',
    English: 'Inglés',
    German: 'Alemán',
  },
};

const mergedTranslations = merge(bookingFormTranslations, merge(langTranslations, engineTranslations));

class Base extends React.Component {
  constructor(props) {
    super(props);
    this.switchFormSummary = this.switchFormSummary.bind(this);
    this.resetSearchListener = this.resetSearchListener.bind(this);
  }

  checkLoginDetails() {
    if (existCookie('login-details')) {
      this.props.dispatch(
        login(
          JSON.parse(getCookieValue('login-details')).username,
          JSON.parse(getCookieValue('login-details')).password,
        ),
      ).then((response) => {
        const loginError = response.success ? null : (
          response.error_message || this.context.t('An error has occurred trying login'));
        this.setState({
          loading: false,
          loginError,
        });
      });
    }
  }

  checkResponsive() {
    const width = window.innerWidth;
    const md = new MobileDetect(window.navigator.userAgent);

    let device;
    let showMobileAlert = false;

    if (md.phone() || width <= 576) {
      device = DEVICES.MOBILE;
      showMobileAlert = window.orientation;
    } else if (width <= 768) {
      device = DEVICES.TABLETV;
    } else if (width <= 1024) {
      device = DEVICES.TABLETH;
    } else {
      device = DEVICES.DESKTOP;
    }
    this.props.setShowAlertMobileLand(showMobileAlert);
    this.props.setDevice(device);
  }

  componentDidUpdate(prevProps) {
    if (prevProps) {
      // Detect showContactUs bookingForm state variable update (click in contact us) to trigger the related GTM event
      const prevShowContactUs = prevProps.showContactUs;
      const currentShowContactUs = this.props.showContactUs;
      if (prevShowContactUs !== currentShowContactUs && currentShowContactUs === true) {
        this.props.sendGTMEvents([{ event: 'event' }]);
      }

      // Update hotel coins conversion rates.
      const prevHotel = prevProps.destination;
      const currentHotel = this.props.destination;
      if (currentHotel && prevHotel !== currentHotel && currentHotel.code) {
        this.props.getConversionRates(currentHotel.code);
      }

      const prevSessionId = prevProps.sessionId;
      const currentSessionId = this.props.sessionId;
      if (prevSessionId !== currentSessionId && currentSessionId != null) {
        if (this.props.sessionId != null) {
          this.props.initializeSignalR(this.props.navigate,
            this.props.location,
            this.props.chainData.signalr_server,
            this.props.sessionId,
            this.props.locator);
        }
      }
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.configureChain();

    if (this.props.sessionId != null) {
      this.props.initializeSignalR(this.props.navigate,
        this.props.location,
        this.props.chainData.signalr_server,
        this.props.sessionId,
        this.props.locator);
    }

    this.props.setFormVisible(true);
    this.props.processIpClientCountryCode();

    // Detectamos dispositivo según resolución
    this.checkResponsive();
    window.addEventListener('resize', () => {
      this.checkResponsive();
    });
    // Detectamos la acción de ir hacia atrás en el navegador.
    // Si se realiza desde una búsqueda previa o la búsqueda por país, volvemos al principio.
    // Configurar el listener para la ubicación

    // Detectamos la acción de ir hacia atrás en el navegador.
    this.resetSearchListener(this.props.location);
  }

  resetSearchListener(location) {
    const isBackToSearch = /^\/(v2\/)?search\//.test(location.pathname);
    const sourceAction = this.props.location.pathname;
    const shouldSkipSearch = sourceAction === '/rooms/';
    if (location.action === 'POP' && shouldSkipSearch && isBackToSearch) {
      this.props.navigate('/');
    }
  }

  componentWillUnmount() {
    //this.unlisten();
  }

  configureChain() {
    const chain = this.getChain();
    const analyticsCfg = chainGTMs[chain];
    configureAnalytics(analyticsCfg.ua, analyticsCfg.gtm);

    // The action to load and configure chain data must always be checked
    this.props.loadAndConfigureChain(chain);

    this.injectFavicon(chain);
    setTheme(chain.toLowerCase());
  }

  getBaseClasses(chain) {
    const classes = [
      `Device${this.props.device}`,
      chain,
    ];
    if (this.props.isFreeModeSelected) {
      classes.push('bookingengine--FreeMode');
    }

    return classes.join(' ');
  }

  getChain() {
    const chainParam = this.props.params.chain;
    if (chainParam && chains.indexOf(chainParam) !== -1) {
      return chainParam;
    }
    if (process.env.MARCONFORT_BOOKING.search(window.location.host) !== -1) {
      return 'MARCONFORT';
    }
    if (process.env.PALMAIARESORTS_BOOKING.search(window.location.host) !== -1) {
      return 'PALMAIARESORTS';
    }
    return 'SANDOS';
  }

  hasAvailError() {
    return !this.props.availLoading && this.props.availError === 'NO_AVAIL';
  }

  hasAvailStep() {
    return BOOKING_STEP.NO_AVAIL_STEP !== this.props.step;
  }

  hasBreadcrumbs() {
    const { pathname } = this.props.location;
    return this.hasAvailStep() && pathname !== '/';
  }

  hasFormSummary() {
    return this.props.step !== BOOKING_STEP.INITIAL && !this.props.formVisible;
  }

  injectFavicon(chain) {
    const cont = document.getElementsByTagName('script')[0];
    if (cont) {
      const elm = document.createElement('link');
      elm.rel = 'icon';
      elm.href = `/img/${chain}_icon.ico`;
      elm.type = 'image/x-icon';
      cont.parentNode.insertBefore(elm, cont);
    }
  }

  isSearchFormEnabled() {
    const { pathname } = this.props.location;
    return pathname !== '/callcenter/login/' && pathname !== '/my-booking/' && pathname.includes('/payment/') === false
    && pathname.includes('/payment-upfront/') === false;
  }

  render() {
    if (!this.props.hasLoadedChain) {
      return <img src="/img/loading5.gif" style={{ margin: '4px' }}/>;
    }

    return (
            <I18n translations={mergedTranslations} initialLang={this.props.lang}>
              {this.renderContent()}
            </I18n>
    );
  }

  renderContent() {
    const {
      showAlertMobLand,
      lang,
      children,
      isCallCenterUser,
      showLogin,
      showLastChanceToRegister,
      showRegistration,
      showRecoverPassword,
      chainData,
      showEditBookingContactInformation,
      showSomeRoomsNotAvailableOnNewDates,
    } = this.props;

    if (showAlertMobLand) {
      return <AlertMobileLand/>;
    }
    // Test
    const chain = this.getChain();
    if (this.props.chainData && !this.props.loggedUser && this.props.sessionId) {
      this.checkLoginDetails();
    }
    return (
            <div className={`bookingEngine ${this.getBaseClasses(chain)}`} id={chain}>
              <CookieBanner lang={lang}/>
              <div className="mainContainer container" id="mainContainer">
                {showLoyaltyRegisterNow() && showLogin && this.props.isLoyaltyUserLoggedIn === false
                  && chainData
                  && <Login2 chainData={chainData} loggedUser={this.props.loggedUser}/>}
                {showLoyaltyRegisterNow() && showLastChanceToRegister
                && chainData && this.props.isLoyaltyUserLoggedIn === false
                && this.props.selectedStatus !== 'becomeMember' && <BookNowRegisterReminder/>}
                {showEditBookingContactInformation && <EditBookingContactInfoPopup/>}
                {showSomeRoomsNotAvailableOnNewDates && window.location.pathname === '/rooms/'
                && <SomeRoomsNotAvailablePopUp/>}
                {showRecoverPassword && <RecoverPasswordModal/>}
                {showRegistration && chainData && <UserRegistration chainData={chainData}/>}
                <Header chain={chain} isCallCenterUser={isCallCenterUser}/>
                {this.hasBreadcrumbs() && this.props.openReservationDetails === false && <Breadcrumbs/>}
                {this.hasAvailError() && <DsCardError/>}
                {this.isSearchFormEnabled() && this.props.openReservationDetails === false && this.renderForm(chain)}
                {children}
              </div>
              <Footer lang={lang}/>
            </div>
    );
  }

  getLocalizedBanner(bannerKey) {
    const config = this.props.chainData?.booking_engine_configuration;
    if (!config) return null;

    const currentLang = this.props.lang;

    // Mapeo de idiomas por si necesitas normalizar (ej: 'en' vs 'eng')
    const langMap = {
      en: 'en',
      es: 'es',
      de: 'de',
      fr: 'fr',
      pt: 'pt',
    };

    const normalizedLang = langMap[currentLang] || currentLang;

    // Prioridad: Banner específico por idioma > Banner por defecto
    const localizedBanner = config[`${bannerKey}_${normalizedLang}`];
    const defaultBanner = config[bannerKey];

    return localizedBanner || defaultBanner;
  }

  renderForm(chain) {
    /* Una de las formas más sencillas de forzar la actualización del componente BookingForm cuando
    cambie filterCurrency.code es usar la propiedad key de React. React utiliza la clave key para
    identificar los componentes y si la clave cambia, React destruirá el componente anterior y lo
    reemplazará por uno nuevo.
    Cuando el valor de filterCurrency.code cambie, podemos actualizar la key de BookingForm para
    forzar su re-renderizado sin afectar al resto del componente Base.
    */
    const formKey = this.props.filterCurrency ? this.props.filterCurrency.code : 'customKey';

    // Verificar si estamos en el home ("/")
    const isHomePage = this.props.location.pathname === '/';

    // Obtener los banners HTML de la configuración (solo si estamos en home)
    // Obtener banners localizados
    const htmlBeforeBookingForm = isHomePage && this.getLocalizedBanner('html_banner_before_booking_form');
    const htmlAfterBookingForm = isHomePage && this.getLocalizedBanner('html_banner_after_booking_form');

    if (this.hasFormSummary()) {
      return <BookingFormSummary onEditClick={this.switchFormSummary}/>;
    }

    // En el css usamos la clase booking-form-sticky-wrapper para fijar el booking form sólo para desktop
    return (
      <div className="booking-form-sticky-wrapper">
        {/* Renderizar banner HTML antes del BookingForm - SOLO EN HOME */}
        {htmlBeforeBookingForm && (
          /* eslint-disable react/no-danger */
          <div
            className="html-banner-before-booking-form"
            dangerouslySetInnerHTML={{ __html: htmlBeforeBookingForm }}
          />
          /* eslint-enable react/no-danger */
        )}

        <BookingForm
          key={formKey} // Usamos filterCurrency.code como key
          usedAsAComponent
          formMode="embedded"
          navigate={this.props.navigate}
          chain={chain}
          theme={chain.toLowerCase()}
          ratetype={this.props.rateType} // Por alguna razón así lo espera en minúsculas
          agentCode={this.props.agentCode}
          agentSell={this.props.agentSell}
          agentusecoins={this.props.agentUseCoins}
          filtercurrencycode={this.props.filterCurrency ? this.props.filterCurrency.code : ''}
          origin={this.props.origin ? this.props.origin : 'BOOKING'}
        />

        {/* Renderizar banner HTML después del BookingForm - SOLO EN HOME */}
        {htmlAfterBookingForm && (
          /* eslint-disable react/no-danger */
          <div
            className="html-banner-after-booking-form"
            dangerouslySetInnerHTML={{ __html: htmlAfterBookingForm }}
          />
          /* eslint-enable react/no-danger */
        )}
      </div>
    );
  }

  switchFormSummary() {
    this.props.setFormVisible(true);
  }
}

Base.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
  location: PropTypes.func.isRequired, // Prop para `navigate`
};

Base.contextTypes = {
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  formVisible: state.bookingFormState.isVisible,
  openReservationDetails: state.session.openReservationDetails,
  chain: state.bookingFormState.chain,
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  step: state.booking.step,
  availLoading: state.booking.availLoading,
  availError: state.booking.availError,
  sessionId: state.bookingFormState.sessionId,
  device: state.booking.device,
  showAlertMobLand: state.session.showAlertMobileLandscape,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  hasLoadedChain: !!state.session.chainData,
  showLogin: state.loyalty.showLogin,
  showLastChanceToRegister: state.loyalty.showLastChanceToRegister,
  lastChanceRegisterConfirmed: state.loyalty.lastChanceRegisterConfirmed,
  chainData: state.session.chainData,
  loggedUser: state.loyalty.loggedUser,
  showRegistration: state.loyalty.showRegistration,
  showRecoverPassword: state.loyalty.showRecoverPassword,
  destination: state.bookingFormState.destination,
  showContactUs: state.bookingFormState.showContactUs,
  locator: state.booking.book_locator,
  showAgentCodeInput: state.bookingFormState.showAgentCodeInput,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
  rateType: state.booking.rateType,
  agentUseCoins: state.booking.agentUseCoins,
  origin: state.bookingFormState.origin,
  filterCurrency: state.booking.filterCurrency,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  selectedStatus: state.loyalty.selectedStatus,
  showEditBookingContactInformation: state.booking.showEditBookingContactInformation,
  showSomeRoomsNotAvailableOnNewDates: state.booking.showSomeRoomsNotAvailableOnNewDates,
  isEditingBooking: state.booking.isEditingBooking,
});

const mapDispatchToProps = (dispatch) => ({
  setFormVisible: (payload) => dispatch(setFormVisible(payload)),
  loadAndConfigureChain: (payload) => dispatch(loadAndConfigureChain(payload)),
  setShowAlertMobileLand: (payload) => dispatch(setShowAlertMobileLand(payload)),
  setDevice: (payload) => dispatch(setDevice(payload)),
  processIpClientCountryCode: (payload) => dispatch(processIpClientCountryCode(payload)),
  sendGTMEvents: (payload) => dispatch(sendGTMEvents(payload)),
  getConversionRates: (payload) => dispatch(getConversionRates(payload)),
  initializeSignalR: (navigate, location, signalr_server, sessionId, locator) => dispatch(
    initializeSignalR(navigate, location, signalr_server, sessionId, locator)),
});

const ConnectedBookingBase = connect(mapStateToProps, mapDispatchToProps)(Base);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedBookingBase);
